"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var DownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M836.63 368.99a48 48 0 01-5.62 67.64L584.36 645.47a112 112 0 01-144.75 0L192.99 436.63a48 48 0 0162.04-73.26l246.62 208.82a16 16 0 0020.68 0l246.66-208.83a48 48 0 0167.65 5.63z" } }] }, "name": "down", "theme": "outlined" };
exports.default = DownOutlined;
